export default __webpack_public_path__ + "static/media/error-500.d7f0e7a0.png";